/**
 * LE CONTEXTE QUE LE SHELL PASSE AU CENTRE : ce qui est ouvert a l'ecran (app,
 * porte, fiche). C'est ce que le bandeau « Fiche ouverte : ... » affiche, ce
 * que la colonne « Fiche suivie » decrit, et ce que Lia recoit, BORNE : des
 * identifiants et des libelles d'interface, jamais le contenu d'une fiche. Le
 * serveur relit la fiche avec les droits du membre (`functions/src/ia/agent.ts`).
 */
export interface ContexteOuvert {
  appId?: string;
  appLabel?: string;
  doorId?: string;
  doorLabel?: string;
  recordId?: string;
  recordTitle?: string;
  /** La famille du jeu de la porte (au pluriel) : l'ancre du chatter d'une fiche. */
  family?: string;
}

/** La fiche qu'une conversation Lia suit : portable d'un ecran a l'autre. */
export interface FicheSuivie {
  appId: string;
  doorId: string;
  recordId: string;
  titre: string;
}

/** La fiche ouverte a l'ecran, ou `null` quand on est sur une collection ou hors d'une app. */
export function ficheOuverte(contexte: ContexteOuvert): FicheSuivie | null {
  if (!contexte.appId || !contexte.doorId || !contexte.recordId) return null;
  return { appId: contexte.appId, doorId: contexte.doorId, recordId: contexte.recordId,
    titre: contexte.recordTitle?.trim() || contexte.doorLabel?.trim() || contexte.recordId };
}

/** « Contact · Personnes », « Contact », ou `null` hors d'une app : le sous-titre de l'en-tete. */
export function libelleDuContexte(contexte: ContexteOuvert): string | null {
  if (contexte.appLabel && contexte.doorLabel) return `${contexte.appLabel} · ${contexte.doorLabel}`;
  return contexte.appLabel ?? null;
}

/** Deux fiches suivies sont la meme fiche : meme app, meme porte, meme id (le titre peut avoir change). */
export function memeFiche(a: FicheSuivie | null, b: FicheSuivie | null): boolean {
  if (a === null || b === null) return a === b;
  return a.appId === b.appId && a.doorId === b.doorId && a.recordId === b.recordId;
}

/**
 * Ce que dit la pastille du composeur d'un sujet Lia : la fiche que le sujet
 * SUIT quand il en a une, sinon la fiche ouverte a l'ecran (qu'il suivra au
 * premier message). `null` : Lia repond sans fiche sous les yeux.
 */
export function ficheDuComposeur(suivie: FicheSuivie | null, ouverte: FicheSuivie | null): { fiche: FicheSuivie; suivie: boolean } | null {
  if (suivie !== null) return { fiche: suivie, suivie: true };
  if (ouverte !== null) return { fiche: ouverte, suivie: false };
  return null;
}
